import {useRouteError} from "react-router-dom";
import ErrorFallback from "./ErrorFallback";

function RouteErrorElement() {
    const routeError = useRouteError()

    return (
        <ErrorFallback error={routeError}/>
    )
}

export default RouteErrorElement;
